export function xRayUndoAction() {
  const { t } = useI18n();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.undo_x_ray') || 'Undo X-Ray',
    getEnabled: function (context) {
      return context.entity.xrayed;
    },
    doAction: function (context) {
      context.entity.xrayed = false;
    },
  };
}
